import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

const sliderComposedClasses = tv({
  slots: {
    root: ["relative"],
    slider: [""],
    wrapper: ["flex items-stretch"],
    slide: ["mb-8  !h-[unset]"],
    pagination: ["flex gap-1.5"],
    textContent: ["justify-between items-center flex"],
    bullets: [
      "size-2 bg-primary-light rounded-full border border-primary-main inline-block cursor-pointer transition-all duration-300 ease-in-out hover:bg-primary-main hover:scale-125",
    ],
    activeBullets: ["w-8", "bg-primary-main"],
  },

  variants: {
    removeContainerPadding: {
      true: {
        root: ["-mx-6"],
      },
    },
    removeSliderPadding: {
      false: {
        slider: ["-mx-6"],
      },
    },
    paginationPosition: {
      left: { pagination: ["justify-start left-6"] },
      center: { pagination: ["justify-center left-0 right-0"] },
      right: { pagination: ["justify-end right-6"] },
    },
    paginationOverlay: {
      true: { pagination: ["absolute mt-0 bottom-6 z-[1]"] },
    },
    isTextContent: {
      true: { textContent: ["items-end"] },
    },
    isMargin: {
      true: { textContent: ["mb-8"] },
    },
  },
  defaultVariants: {
    removeContainerPadding: true,
    removeSliderPadding: true,
    paginationPosition: "center",
    isMargin: false,
  },
});

export const {
  root: sliderRootClasses,
  slider: sliderClasses,
  wrapper: wrapperClasses,
  slide: slideClasses,
  pagination: sliderPaginationClasses,
  textContent: sliderTextContentClasses,
  bullets: sliderBulletsClasses,
  activeBullets: sliderActiveBulletsClasses,
} = sliderComposedClasses();

export const bottomNavigationButtonClasses = tv({
  base: ["absolute", "top-1/2", "z-[1] -mt-3", "!p-2"],
  variants: {
    left: {
      true: ["left-0", "-translate-x-1/2", "-translate-y-1/2"],
    },
    right: {
      true: ["right-0", "translate-x-1/2", "-translate-y-1/2"],
    },
    isCentered: {
      true: ["mt-0"],
    },
    isInner: {
      true: [""],
    },
  },
  compoundVariants: [
    {
      left: true,
      isInner: true,
      className: ["translate-x-0", "-translate-y-1/2"],
    },
    {
      right: true,
      isInner: true,
      className: ["translate-x-0", "-translate-y-1/2"],
    },
    {
      isCentered: true,
      isInner: true,
      className: [
        "bg-transparent",
        "border-none",
        "p-0",
        "shadow-none",
        "hover:bg-transparent",
        "focus:ring-0",
        "text-primary-main",
      ],
    },
  ],
});
export const navigationIconClasses = tv({
  base: ["text-current"],
  variants: {
    isInner: {
      true: ["w-9 h-9"],
      false: ["w-5 h-5"],
    },
  },
});

export type SliderRootVariants = VariantProps<typeof sliderRootClasses>;
export type SliderVariants = VariantProps<typeof sliderClasses>;
export type SliderPaginationVariants = VariantProps<
  typeof sliderPaginationClasses
>;
